import Search from 'assets/svg/loaders/searching-for-opponent.png?format=webp;avif&as=picture';
import WaitingForOpponent from 'assets/svg/loaders/waiting-for-opponent-move.png?format=webp;avif&as=picture';
import WaitingForOpponentReveal from 'assets/svg/loaders/waiting-for-opponent-reveal.png?format=webp;avif&as=picture';
import WaitingForYourMove from 'assets/svg/loaders/waiting-for-your-choice.png?format=webp;avif&as=picture';
import WaitingForYourReveal from 'assets/svg/loaders/waiting-for-your-reveal.png?format=webp;avif&as=picture';
import WaitingToAccept from 'assets/svg/loaders/waiting-to-accept.png?format=webp;avif&as=picture';

import { MoveStatusType } from './MoveStatusRenderer.types';

type IconData = {
  sources: Record<string, string>;
  img: {
    src: string;
    w: number;
    h: number;
  };
};

export const getStatusIcon = (statusIcon: MoveStatusType) => {
  const iconMap: Record<MoveStatusType, IconData | null> = {
    [MoveStatusType.SEARCH]: Search,
    [MoveStatusType.WAITING_TO_ACCEPT]: WaitingToAccept,
    [MoveStatusType.WAITING_FOR_YOUR_MOVE]: WaitingForYourMove,
    [MoveStatusType.WAITING_FOR_OPPONENT]: WaitingForOpponent,
    [MoveStatusType.WAITING_FOR_YOUR_REVEAL]: WaitingForYourReveal,
    [MoveStatusType.WAITING_FOR_OPPONENT_REVEAL]: WaitingForOpponentReveal,
  };

  return iconMap[statusIcon] ?? null;
};
